import { GET_USER_FAILURE, GET_USER_REQUEST, GET_USER_RESET, GET_USER_SUCCESS, UPDATE_USER_ROLE_FAILURE, UPDATE_USER_ROLE_REQUEST, UPDATE_USER_ROLE_RESET, UPDATE_USER_ROLE_SUCCESS } from "redux/actions/action-type";

const initalState = {
    getUserResponse: {},
    isGetUserError: false,
    isGetUserSuccess: false,
    isGetUserLoading: false,
    updateUserRoleResponse: {},
    isUpdateUserRoleError: false,
    isUpdateUserRoleSuccess: false,
    isUpdateUserRoleLoading: false,
};

const addUserReducer = (state = initalState, { type, getUserResponse, updateUserRoleResponse }) => {
    switch (type) {
        case GET_USER_REQUEST:
            return {
                ...state,
                isGetUserLoading: true,
                isGetUserError: false,
                isGetUserSuccess: false,
                isUpdateUserRoleLoading: false,
                isUpdateUserRoleError: false,
                isUpdateUserRoleSuccess: false
            };
        case GET_USER_SUCCESS:
            return {
                ...state,
                getUserResponse: getUserResponse,
                isGetUserLoading: false,
                isGetUserError: false,
                isGetUserSuccess: true,
                isUpdateUserRoleLoading: false,
                isUpdateUserRoleError: false,
                isUpdateUserRoleSuccess: false
            };
        case GET_USER_FAILURE:
            return {
                ...state,
                getUserResponse: getUserResponse,
                isGetUserLoading: false,
                isGetUserError: true,
                isGetUserSuccess: false,
                isUpdateUserRoleLoading: false,
                isUpdateUserRoleError: false,
                isUpdateUserRoleSuccess: false
            };
        case GET_USER_RESET:
            return {
                ...initalState,
            };
        case UPDATE_USER_ROLE_REQUEST:
            return {
                ...state,
                getUserResponse: {},
                isGetUserLoading: false,
                isGetUserError: false,
                isGetUserSuccess: false,
                isUpdateUserRoleLoading: true,
                isUpdateUserRoleError: false,
                isUpdateUserRoleSuccess: false
            };
        case UPDATE_USER_ROLE_SUCCESS:
            return {
                ...state,
                updateUserRoleResponse: updateUserRoleResponse,
                getUserResponse: {},
                isGetUserLoading: false,
                isGetUserError: false,
                isGetUserSuccess: false,
                isUpdateUserRoleLoading: false,
                isUpdateUserRoleError: false,
                isUpdateUserRoleSuccess: true,
            };
        case UPDATE_USER_ROLE_FAILURE:
            return {
                ...state,
                updateUserRoleResponse: updateUserRoleResponse,
                getUserResponse: {},
                isGetUserLoading: false,
                isGetUserError: false,
                isGetUserSuccess: false,
                isUpdateUserRoleLoading: false,
                isUpdateUserRoleError: true,
                isUpdateUserRoleSuccess: false
            };
        case UPDATE_USER_ROLE_RESET:
            return {
                ...initalState
            }
        default:
            return state;
    }
};

export default addUserReducer;